import Vue from "vue"
import Router from "vue-router"
import { type_webpage_catalogDownload, type_webpage_guideVisit, type_webpage_procurementMatchmaking } from "../constants"

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)
import routerGuard from './routerGuard.js'
import { isExhibitor } from "../utils"

const routes = [
  { path: "/", redirect: "/login" },
  {
    path: "/login", meta: {
      title: "登录",
      keepAlive: true
    },
    component: () => import("../pages/user/login.vue")
  },
  {
    name: "home",
    path: "/login",
    meta: {
      title: "登录",
      keepAlive: true
    },
    component: () => import("../pages/user/login")
  },
  {
    name: "home",
    path: "/home",
    meta: {
      title: "观众首页", //游客+观众首页
      keepAlive: true
    },
    component: () => import("../pages/home")
  },
  {
    name: "metaverse",
    path: "/metaverse", 
    meta: {
        title: "元宇宙会议",
        keepAlive: false
    },
    component: () =>
        import ("@wenxing/components/metAverseDetail.vue")
},
  { path: "/exhibition", redirect: "/exhibition/index" },
  {
    name: "展商首页",
    path: "/exhibition/index",
    meta: {
      title: "展商首页",
      keepAlive: true
    },
    component: () => import("@wenxing/pages/home")
  },
  { path: "/purchaser", redirect: "/purchaser/index" },
  // 购买商
  {
    name: "观众首页",
    path: "/purchaser/index",
    meta: {
      title: "观众首页",
      keepAlive: true
    },
    component: () => import("@wenxing/pages/home/index.vue")
  },
  //注册界面
  {
    name: "注册界面",
    path: "/purchaser/register",
    meta: {
      title: "注册界面",
    },
    component: () => import("@wenxing/pages/purchaser/register.vue")
  },
  //注册成功界面
  {
    name: "注册成功界面",
    path: "/purchaser/registerSuccess",
    meta: {
      title: "注册成功界面",
    },
    component: () => import("@wenxing/pages/purchaser/register/registerSuccess.vue")
  },
  // 注册crm问卷返回自动登录
  {
    name: "自动登录",
    path: "/purchaser/autoLogin",
    meta: {
      title: "自动登录",
    },
    component: () => import("@wenxing/pages/purchaser/autoLogin.vue")
  },
  //切换展区
  {
    name: "切换展区",
    path: "/exhibtArea/change",
    meta: {
      title: "切换展区", //切换展区
    },
    component: () => import("@wenxing/pages/exhibtArea/changeArea.vue")
  },
  //切换展区3d
  {
    name: "切换展区3d",
    path: "/exhibtArea/change3d",
    meta: {
      title: "切换展区", //切换展区
    },
    component: () => import("@wenxing/pages/exhibtArea/changeArea3d.vue")
  },
  //切换展区3d
  {
    name: "切换展区3d测试",
    path: "/exhibtArea/change3dcopy",
    meta: {
      title: "切换展区测试", //切换展区
    },
    component: () => import("@wenxing/pages/exhibtArea/changeArea3dcopy.vue")
  },
  //展区列表
  {
    name: "展区列表",
    path: "/exhibtArea/areaList",
    meta: {
      title: "展区列表", //展区列表
    },
    component: () => import("@wenxing/pages/exhibtArea/areaList.vue")
  },
  // 序厅
  {
    name: "序厅",
    path: "/exhibtArea/lobby",
    meta: {
      title: "序厅", //序厅
    },
    component: () => import("@wenxing/pages/exhibtArea/lobby.vue")
  },
  // 3D序厅
  {
    name: "序厅",
    path: "/exhibtArea/lobby3d",
    meta: {
      title: "序厅", //序厅
    },
    component: () => import("@wenxing/pages/exhibtArea/lobby3d.vue")
  },
  // 3D入口
  {
    name: "3D入口",
    path: "/exhibtArea/vrhost",
    meta: {
      title: "3D入口", //3D入口
    },
    component: () => import("@wenxing/pages/exhibtArea/vrhost.vue")
  },
  // vrPreview
  {
    name: "VR查看",
    path: "/me/exhibtArea/vrPreview",
    meta: {
      title: "VR查看", //序厅
    },
    component: () => import("@wenxing/pages/vrbooth/vrPreview.vue")
  },
  //直播详情
  {
    name: "直播详情",
    path: "/liveDetail/one/:id",
    meta: {
      title: "直播详情", //游客+观众首页
    },
    component: () => import("../pages/liveDetail/one")
  },
  //视频播放界面  历史回放
  {
    name: "视频播放界面",
    path: "/video/:url",
    meta: {
      title: "视频播放界面",
    },
    component: () => import("../pages/video2")
  },

  {
    name: "liveDetail-no-cruise",
    path: "/liveDetail/no-cruise",
    meta: {
      title: "主办直播详情（非巡馆）", //游客+观众首页
      keepAlive: true
    },
    component: () => import("../pages/liveDetail/no-cruise")
  },
  {
    name: "liveDetail-cruise",
    path: "/liveDetail/cruise",
    meta: {
      title: "主办直播详情（非巡馆）", //游客+观众首页
      keepAlive: true
    },
    component: () => import("../pages/liveDetail/cruise")
  },
  {
    name: "现场直播",
    path: "/conferenceLive",
    meta: {
      title: "现场直播",
    },
    component: () => import("../pages/conferenceLive")
  },
  {
    name: "项目推介会-平台操作指引-会刊下载",
    path: "/webpage/:type",
    meta: {
      title: "项目推介会-平台操作指引-会刊下载",
    },
    component: () => import(`../pages/siglePage.vue`)
  },
  {
    name: "综合服务",
    path: "/compreService",
    meta: {
      title: "综合服务",
    },
    component: () => import(`../pages/compreService.vue`)
  },
  //采购商列表
  {
    meta: {
      keepAlive: false
    },
    path: "/purchaserList",
    component: () => import("@wenxing/pages/purchaserList.vue")
  },
  // 观众详情
  {
    path: "/purchaser/:id",
    component: () => import("@wenxing/pages/purchaserDetail.vue")
  },
  //需求列表
  {
    meta: {
      keepAlive: false
    },
    path: "/demandList",
    component: () => import("@wenxing/pages/demandList.vue")
  },
  // 需求详情
  {
    path: "/demand/:id",
    component: () => import("@wenxing/pages/demandDetail.vue")
  },
  //展商列表
  {
    name: "wenxing-purchaser-exhibition",
    path: "/exhibitionList",
    meta: {
      keepAlive: false,
      title: "展商列表"
    },
    component: () => import("@wenxing/pages/exhibitionList.vue")
  },
  // 展商详情
  {
    name: "wenxing-purchaser-exhibition-detail",
    path: "/exhibition/:id",
    meta: {
      title: "展商详情"
    },
    component: () => import("@wenxing/pages/exhibitionDetail.vue")
  },
  //展品列表
  {
    name: "wenxing-purchaser-exhibit-list",
    path: "/exhibitsList",
    meta: {
      keepAlive: false,
      title: "展品列表"
    },
    component: () => import("@wenxing/pages/exhibitsList.vue")
  },
  //展品详情
  {
    name: "wenxing-purchaser-exhibit-detail",
    path: "/exhibit/:id",
    meta: {
      title: "展品详情"
    },
    component: () => import("@wenxing/pages/exhibitDetail.vue")
  },
  // 直播列表
  {
    path: "/livingList",
    meta: {
      keepAlive: true
    },
    component: () => import("@wenxing/pages/living/livingList.vue")
  },
  // 分类直播列表
  {
    meta: {
      keepAlive: true
    },
    path: "/classifyLivingList",
    component: () => import("@wenxing/pages/living/classifyLivingList.vue")
  },
  // 大会快看列表
  {
    meta: {
      keepAlive: true
    },
    path: "/meetLivingList",
    component: () => import("@wenxing/pages/living/meetLivingList.vue")
  },
  // 展会现场实时直播列表
  {
    meta: {
      keepAlive: true
    },
    path: "/exhibitSceneLivingList",
    component: () => import("@wenxing/pages/living/exhibitSceneLivingList.vue")
  },
  // 全球大咖带你sign china
  {
    meta: {
      keepAlive: true
    },
    path: "/worldLivingList",
    component: () => import("@wenxing/pages/living/worldLivingList.vue")
  },
  // 会议视频列表
  {
    meta: {
      keepAlive: true
    },
    path: "/meetSceneLivingList",
    component: () => import("@wenxing/pages/living/meetSceneLivingList.vue")
  },
  // 展商直播列表
  {
    name: "展商直播列表",
    meta: {
      keepAlive: true
    },
    path: '/exhibitionLivingList',
    component: () => import("@wenxing/pages/living/exhibitionLivingList.vue")
  },
  {
    name: "展商直播列表2",
    path: '/exhibitionLivingList2',
    component: () => import("@wenxing/pages/living/exhibitionLivingList2.vue")
  },
  //普通展商直播
  {
    name: "普通展商直播",
    path: '/liveDetail/exhibitorLiveDetail/:liveId',
    component: () => import("@wenxing/pages/liveDetail/exhibitorLiveDetail.vue")
  },
  //视频聊天
  {
    name: "视频聊天",
    path: '/videoCall/detail',
    component: () => import("@wenxing/pages/commonPage/videoCall/index.vue")
  },
  {
    name: "会议视频聊天",
    path: '/meetting/detail',
    component: () => import("@wenxing/pages/commonPage/meeting/index.vue")
  },
  ...require("./exhibitor/index").default, //参展商
  ...require("./purchaser/index").default,//观众
  { path: "/*", redirect: "/home" },

]


const router = new Router({
  mode: "history",
  base: "pc",
  routes: routes
})

//加入路由 守卫 Guard
routerGuard(router)

export default router



// WEBPACK FOOTER //
// ./src/wenxing/router/index.js